import { render } from "./store-details.vue?vue&type=template&id=0d6a2ac0"
import script from "./store-details.vue?vue&type=script&setup=true&lang=js"
export * from "./store-details.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/trendyol/store-details.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d6a2ac0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d6a2ac0', __exports__)) {
    console.log('reload')
    api.reload('0d6a2ac0', __exports__)
  }
  
  module.hot.accept("./store-details.vue?vue&type=template&id=0d6a2ac0", () => {
    console.log('re-render')
    api.rerender('0d6a2ac0', render)
  })

}


export default __exports__